import { useExperimentalFeature } from "@istari-frontend/experimental-features";
import type { ReactNode } from "react";
import { Navigate } from "react-router";

import { routes } from "~/routes";

type ExperimentalDashboardGuardProps = {
  feature: "resource-redesign" | "system-redesign";
  redirectTo: string;
  children: ReactNode;
};

function ExperimentalDashboardGuard({ feature, redirectTo, children }: ExperimentalDashboardGuardProps) {
  const { available } = useExperimentalFeature(feature);
  if (!available) {
    return <Navigate to={redirectTo} replace />;
  }
  return <>{children}</>;
}

export function ResourcesDashboardGuard({ children }: { children: ReactNode }) {
  return (
    <ExperimentalDashboardGuard feature="resource-redesign" redirectTo={routes.Resources}>
      {children}
    </ExperimentalDashboardGuard>
  );
}

export function SystemsDashboardGuard({ children }: { children: ReactNode }) {
  // Availability, not the user's toggle: the route stays reachable for a user who has the redesign
  // switched off, so a link into the dashboard still works.
  return (
    <ExperimentalDashboardGuard feature="system-redesign" redirectTo={routes.Systems}>
      {children}
    </ExperimentalDashboardGuard>
  );
}
